// src/components/StatsCards.js
import React from 'react';

const StatsCards = ({ stats }) => {
  return (
    <div className="container">
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Total</div>
          <div className="stat-value">{stats.total}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Scrapés</div>
          <div className="stat-value gray">{stats.scrapped}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">En révision</div>
          <div className="stat-value orange">{stats.review}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Validés</div>
          <div className="stat-value green">{stats.validated}</div>
        </div>
      </div>
    </div>
  );
};

export default StatsCards;